const MaxWidth = 1224;

export { MaxWidth };
